module.exports = __webpack_public_path__ + "www/1670826376000/img/app-02.e7e4c81.png";